import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';
import _ from 'static/script/libs/underscore';
import Storage from 'static/script/app/data/storage-service';
import Logger from 'static/script/utils/logger';

function SearchSuggestion() {
    this._currentCategoryId = 0;
    this._searchRecentStorage = new Storage('search-recent');

    this.defaultAttrs({
        autocompletelinklist:
            '.search-recent-list a, .search-suggestion-list a',
        recentList: '[data-search-recent-list]',
        recentListTemplate: '[data-search-recent-list-template]',
        saveRecent: '[data-save-recent]',
        selectedSuggestion: '.search-suggestion-state-hover',
        suggestionLink: '[data-search-suggestion-type]',
        suggestionLinkAttribute: 'search-suggestion-type',
        suggestionList: '[data-search-suggestion-list]',
        suggestionListItem: '[data-search-suggestion-item]',
        suggestionListLinkCategory: 'search-category-id',
        suggestionListLinkShop: 'search-suggestion-shop',
        suggestionListLinkHoverCssClass: 'search-suggestion-state-hover',
        suggestionListLinkSuggestion: 'search-suggestion-text',
        suggestionListLinkText: '[data-search-suggestion-list-text]',
        suggestionListTemplate: '[data-search-suggestion-list-template]'
    });

    this._suggestionsReceived = function(evt, payload) {
        this._renderResults(
            payload.suggestions,
            'suggestionListTemplate',
            'suggestionList'
        );
        this._emphasizeResults(payload.suggestions.query);
    };

    this._renderResults = function(payload, template, list) {
        payload.categoryId = this._currentCategoryId;
        let tmpl = this.select(template).html();
        let html = _.template(tmpl);
        this.select(list).html(html(payload));
        this._toggleInspiration();
    };

    this._toggleInspiration = function(showInspiration) {
        if (!showInspiration && showInspiration !== false) {
            showInspiration = this.select('suggestionListItem').length > 0;
        }
        if (showInspiration === false) {
            this.$node.fadeOut(
                'fast',
                function() {
                    this.$node.hide();
                }.bind(this)
            );
        } else {
            this.$node.toggle(showInspiration);
            var searchInput = document.querySelector(
                '.site-header-search2__input'
            );
            if (searchInput) {
                // TODO Fix when splittest is done, this IF should not be needed
                var searchInputClientRect = searchInput.getBoundingClientRect();
                var myPosition = {
                    top: searchInputClientRect.bottom,
                    left: searchInputClientRect.left,
                    width: searchInputClientRect.width - 50
                };
                this.$node.css(myPosition);
            }
        }
        this.trigger(document, 'ui:search-suggestion:on-toggle-inspiration', {
            show: showInspiration
        });
    };

    this._closeInspiration = function() {
        this._toggleInspiration(false);
    };

    this._clearInspiration = function() {
        this.select('suggestionList').html('');
        this.select('recentList').html('');
    };

    // For case-insensitive string replace - http://phpjs.org/functions/preg_quote/
    this._pregQuote = function(str) {
        return (str + '').replace(
            /([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\|\:])/g,
            '\\$1'
        );
    };

    this._emphasize = function(text, query) {
        return text.replace(
            new RegExp('(' + this._pregQuote(query) + ')', 'i'),
            '<em>$1</em>'
        );
    };

    this._emphasizeResults = function(query) {
        if (!query) {
            return;
        }
        let emphasize = this._emphasize.bind(this);
        this.select('suggestionListLinkText').each(function() {
            let $this = $(this);
            $this.html(emphasize(_.unescape($this.text()), query));
        });
    };

    this._getSuggestionText = function(evtTarget) {
        return decodeURIComponent(
            $(evtTarget).data(this.attr.suggestionListLinkSuggestion)
        );
    };

    this._getSuggestionType = function(evtTarget) {
        return $(evtTarget).data(this.attr.suggestionLinkAttribute);
    };

    /** Inspiration key-navigation */
    this._navigateSuggestions = function(evt, payload) {
        let selectedSuggestion = this._getSelectedSuggestion();
        let navigatingDown = payload.arrowKeyDirection === 'DOWN';

        if (!selectedSuggestion && !navigatingDown) {
            return;
        }

        let linklist = this.select('autocompletelinklist');
        let nextIndex = 0;

        if (selectedSuggestion.length > 0) {
            let currentIndex = linklist.index(selectedSuggestion);
            nextIndex = navigatingDown ? currentIndex + 1 : currentIndex - 1;

            if (nextIndex >= linklist.length) {
                // reached bottom of list
                nextIndex = 0;
            }
        }
        this._selectSuggestionInList(nextIndex, linklist);
    };

    this._getSelectedSuggestion = function() {
        return this.select('selectedSuggestion');
    };

    this._getSelectedSuggestionType = function() {
        return (
            this.select('selectedSuggestion').data(
                this.attr.suggestionLinkAttribute
            ) || ''
        );
    };

    this._selectSuggestionInList = function(
        nextSuggestionIndexToSelect,
        suggestionList
    ) {
        let nextSuggestionToSelect = suggestionList.eq(
            nextSuggestionIndexToSelect
        );
        let payload = {
            query: decodeURIComponent(
                nextSuggestionToSelect.data(
                    this.attr.suggestionListLinkSuggestion
                )
            ),
            categoryId:
                nextSuggestionToSelect.data(
                    this.attr.suggestionListLinkCategory
                ) || 0,
            shopUrl: nextSuggestionToSelect.data(
                this.attr.suggestionListLinkShop
            )
        };

        suggestionList.removeClass(this.attr.suggestionListLinkHoverCssClass);
        nextSuggestionToSelect.addClass(
            this.attr.suggestionListLinkHoverCssClass
        );
        this.trigger(
            document,
            'ui:search-suggestion:on-autocomplete-select',
            payload
        );
    };

    this._displayRecentSearches = function(evt, evtData) {
        let recent = this._queryRecentSearches(evtData.query);
        this._recentSearches = { searches: recent, shops: [] };
        this._renderResults(
            this._recentSearches,
            'recentListTemplate',
            'recentList'
        );
        this._emphasizeResults(evtData.query);
    };

    this._fetchAllRecentSearches = function() {
        let allRecent = this._searchRecentStorage.fetch().orderByTimestamp();
        return this._mapStorageToSuggestions(allRecent);
    };

    this._mapStorageToSuggestions = function(storageCollection) {
        function mapStorageToSuggestions(item) {
            return {
                text: item.key,
                link: encodeURIComponent(item.key),
                count: item.value
            };
        }
        return _.map(storageCollection, mapStorageToSuggestions);
    };

    this._queryRecentSearches = function(query) {
        if (query === '') {
            return this._fetchAllRecentSearches().splice(0, 7);
        }

        let allRecent = this._searchRecentStorage.fetch().orderByValue(),
            recent = [];

        recent = _.filter(allRecent, function(item) {
            return (
                query.toLowerCase() ===
                item.key.substr(0, query.length).toLowerCase()
            );
        });

        return this._mapStorageToSuggestions(recent).splice(0, 3);
    };

    this._filterRecentFromSuggestions = function(payload) {
        // Only used by a test
        let recent = _.pluck(this._recentSearches.searches, 'text');

        return _.filter(payload, function(item) {
            return recent.indexOf(item.text) === -1;
        });
    };

    this._saveAsRecent = function(evt, evtData) {
        if (this._getSelectedSuggestionType() === 'shop suggestion') {
            return;
        }

        let query =
                evt.type === 'click'
                    ? this._getSuggestionText(evt.target)
                    : evtData.query,
            recentCount,
            prettyQuery = this._stripBadChars(query);

        if (prettyQuery && prettyQuery.length > 2) {
            recentCount = this._searchRecentStorage.get(prettyQuery) || 0;
            recentCount += 1;
            this._saveRecentSearch(prettyQuery, recentCount);
        }
    };

    this._stripBadChars = function(stringToStrip) {
        return stringToStrip
            .toString()
            .replace(/</g, ' ')
            .replace(/>/g, ' ')
            .trim();
    };

    this._saveRecentSearch = function(query, recentCount) {
        try {
            this._searchRecentStorage.set(query, recentCount);
        } catch (ex) {
            this.logError(ex, 'Failed to save recent search');
            if (this._searchRecentStorage) {
                this._searchRecentStorage.flush();
            }
        }
    };

    this._submitSearch = function(evt, payload) {
        let suggestionType = this._getSelectedSuggestionTypeLabel(payload);
        this._triggerSearchEvent(
            payload.query,
            payload.categoryId,
            suggestionType,
            'enter'
        );
    };

    this._getSelectedSuggestionTypeLabel = function(payload) {
        let selectedSuggestionType = this._getSelectedSuggestionType();

        if (selectedSuggestionType.length) {
            return selectedSuggestionType;
        }

        if (payload.query.length === 0) {
            return 'category browse';
        }

        return 'normal';
    };

    this._triggerSearchEvent = function(
        query,
        categoryId,
        suggestionType,
        searchAction
    ) {
        let payload = {
            query: query,
            categoryId: categoryId,
            suggestionType: suggestionType,
            searchAction: searchAction
        };

        this.trigger(document, 'ui:search-suggestion:before-search', payload);
    };

    this._suggestionClicked = function(evt) {
        let query = this._getSuggestionText(evt.target);
        let suggestionType = this._getSuggestionType(evt.target);
        let categoryId = this._currentCategoryId;

        this._triggerSearchEvent(query, categoryId, suggestionType, 'click');
    };

    this._setCurrentCategoryId = function(evt, payload) {
        this._currentCategoryId = payload.categoryId || 0;
    };

    this._init = function() {
        this._currentCategoryId =
            $('[data-site-header-search-category-dropdown]').val() || 0;
    };

    this.after('initialize', function() {
        this._init();

        this.on('click', {
            saveRecent: this._saveAsRecent,
            suggestionLink: this._suggestionClicked
        });

        this.on(
            document,
            'data:search-suggestion:on-suggestion-complete',
            this._suggestionsReceived
        );
        this.on(
            document,
            'ui:site-search:on-search-field-input',
            this._displayRecentSearches
        );
        this.on(
            document,
            'ui:site-search:on-search-field-focusin',
            this._displayRecentSearches
        );
        this.on(
            document,
            'ui:site-search:on-navigate',
            this._navigateSuggestions
        );

        this.on(document, 'ui:site-search:on-search', this._saveAsRecent);
        this.on(document, 'ui:site-search:on-search', this._submitSearch);

        this.on(
            document,
            'data:navigation:after-page-load',
            this._clearInspiration
        );
        this.on(
            document,
            'data:navigation:after-page-load',
            this._closeInspiration
        );
        this.on(
            document,
            'data:navigation:before-page-load',
            this._closeInspiration
        );
        this.on(
            document,
            'ui:site-search:on-search-field-blur',
            this._closeInspiration
        );
        this.on(
            document,
            'ui:site-search:after-category-change',
            this._setCurrentCategoryId
        );
    });
}

export default Logger.mixin(SearchSuggestion);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-suggestion.js